import createHTMLMediaHook from './util/createHTMLMediaHook';
var useVideo = createHTMLMediaHook('video');
export default useVideo;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useVideo.js
// module id = fr9b
// module chunks = 0